import { OwaWorkload } from 'owa-workloads';
import { RefreshStrategy } from './schema/RefreshStrategy';
import { SettingsMetaData } from './schema/SettingsMetaData';

export function getWhitelistedSessionDataSettings() {
    return {
        SessionSettings: {
            UserEmailAddress: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'email',
                keyLabel: 'email address',
            },
            UserCulture: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.Reload],
                ]),
                keyCategoryLabel: 'locale',
                keyLabel: 'culture',
            },
            UserDisplayName: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'display name',
                keyLabel: 'display name',
            },
            DefaultPublicFolderMailbox: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'default public folder mailbox',
                keyLabel: 'default public folder mailbox',
            },
            IsUserCultureRightToLeft: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.Reload],
                ]),
                keyCategoryLabel: 'default public folder mailbox',
                keyLabel: 'default public folder mailbox',
            },
        },
        UserOptions: {
            MailboxTimeZoneOffset: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.Reload],
                ]),
                keyCategoryLabel: 'timezone',
                keyLabel: 'timezone',
            },
            WeekStartDay: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'weekstartday',
                keyLabel: 'weekstartday',
            },
            DefaultReminderTimeInMinutes: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'defaultReminder',
                keyLabel: 'defaultReminder',
            },
            AddOnlineMeetingToAllEvents: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'addOnlineMeetingToAllEvents',
                keyLabel: 'addOnlineMeetingToAllEvents',
            },
        },
        ViewStateConfiguration: {
            SelectedCalendarsTNarrow: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'calendar selection',
                keyLabel: 'calendar selection',
            },
        },
        MasterCategoryList: <SettingsMetaData>{
            RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
            ]),
            keyCategoryLabel: 'calendar selection',
            keyLabel: 'calendar selection',
        },
        PolicySettings: {
            PlacesEnabled: <SettingsMetaData>{
                RefreshStrategy: new Map<OwaWorkload, RefreshStrategy>([
                    [OwaWorkload.Calendar, RefreshStrategy.HydrationWithoutMessage],
                ]),
                keyCategoryLabel: 'places enabled',
                keyLabel: 'places enabled',
            },
        },
    };
}
